import styled from 'styled-components';

export const FooterStyle = styled.footer`
  display: flex; 
  justify-content: center;
  flex-direction: flex-end;
  margin-top: auto;
  background-color: rgb(255, 255, 255, 0.7);
  text-align: center;
  font-size: 10px;
  width: 100%;
`;
